import React from 'react';

interface LocationInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  maxLength?: number;
  onUseCurrentLocation?: () => void;
  isGettingLocation?: boolean;
}

export function LocationInput({
  id,
  label,
  value,
  onChange,
  onBlur,
  error,
  maxLength,
  onUseCurrentLocation,
  isGettingLocation = false,
}: LocationInputProps) {
  return (
    <div>
      <label htmlFor={id} className="mb-2 block text-[14px] font-normal leading-[170%] text-[#3B3B3B]">
        {label}
      </label>
      <div className="relative">
        <input
          type="text"
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          maxLength={maxLength}
          style={{
            borderWidth: '1.5px',
            borderStyle: 'solid',
            borderColor: error ? '#EF4444' : '#E5E7EB',
            padding: '12px 16px',
            paddingRight: onUseCurrentLocation ? '200px' : '16px',
          }}
          className="w-full rounded-lg bg-white text-[16px] leading-[170%] text-[#3B3B3B] placeholder:text-[#3B3B3B]/40 focus:outline-none focus:ring-2 focus:ring-[#7CF1C7] focus:border-transparent"
          placeholder="Enter Zip Code"
        />
        {onUseCurrentLocation && (
          <button
            type="button"
            onClick={onUseCurrentLocation}
            disabled={isGettingLocation}
            className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-2 text-[14px] text-[#183344] hover:text-[#0D1F2D] transition-colors disabled:opacity-50"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="flex-shrink-0"
            >
              <path
                d="M8 8.66667C8.73638 8.66667 9.33333 8.06971 9.33333 7.33333C9.33333 6.59695 8.73638 6 8 6C7.26362 6 6.66667 6.59695 6.66667 7.33333C6.66667 8.06971 7.26362 8.66667 8 8.66667Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 14C10 11.3333 13.3333 9.07619 13.3333 6.66667C13.3333 3.72115 10.9455 1.33333 8 1.33333C5.05448 1.33333 2.66667 3.72115 2.66667 6.66667C2.66667 9.07619 6 11.3333 8 14Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="whitespace-nowrap">
              {isGettingLocation ? 'Getting location...' : 'Use my current Location'}
            </span>
          </button>
        )}
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}
